<template>
  <v-container fluid pa-0 ma-0>
    <v-dialog
      v-if="selectedExtension.softPhoneDetails"
      v-model="dialog"
      max-width="500px"
    >
      <soft-phone
        :extension="selectedExtension"
        @DialogStatus="updateExtension($event)"
      ></soft-phone>
    </v-dialog>
    <v-dialog v-model="phoneNumberDialog" persistent>
      <ReservedNumber
        :_phoneNumber="selectedRow"
        :selectedIndex="selectedIndex"
        @reservePhoneNumber="onAddReservedNumber"
        @closeDialog="closeDialog"
      />
    </v-dialog>
    <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row justify-space-between>
          <v-flex v-show="!isQantas" xs2>
            <v-radio-group
              v-model="isCreatedByAMPT"
              column
              value="true"
              class="ptop-0"
            >
              <v-radio
                name="ampt"
                :value="false"
                label="Standard PBX"
              ></v-radio>
              <v-radio
                name="ampt"
                :value="true"
                label="Created by AMPT"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 style="display: flex; align-items: center">
            <v-btn
              v-if="ipOrderID"
              color="primary"
              @click="deleteFromOrder(ipOrderID)"
            >
              Delete from {{ isQuote ? 'Quote' : 'Order' }}
            </v-btn>
          </v-flex>

          <existing-services
            :dialog="existingDialog"
            :headers="headers"
            :account="customer.customer.ubAccountNo"
            :service-type="'VoIP'"
            @close="existingDialog = !existingDialog"
            @selectedItems="addToTable"
            @selectedSoftphoneItems="addSoftPhoneToTable"
            @loaded="existingServicesLoaded"
          ></existing-services>
        </v-layout>
        <v-flex v-show="isCreatedByAMPT" xs12 sm12 md6 lg6>
          <vonex-text
            ref="amptDomainName"
            v-model="amptDomainName"
            name="amptDomainName"
            label="AMPT Domain Name"
            :rule="isCreatedByAMPT ? 'required|ampt' : ''"
            :options="fieldConditions"
          ></vonex-text>
          <!-- <v-text-field
            label="AMPT Domain Name"
            name="amptDomainName"
            v-validate="isCreatedByAMPT ? 'required|ampt' : ''"
            v-model="amptDomainName"
          />-->
          <!-- <span v-show="errors.has('amptDomainName')" class="text-danger">Domain Name is invalid</span> -->
        </v-flex>
        <v-container xs12 ma-0 pa-0>
          <v-layout row fill-height>
            <v-flex align-start justify-center column fill-height>
              <v-flex v-if="showButton">
                <v-btn
                  color="primary"
                  :disabled="voipServices.length == 0"
                  @click="showExistingServices()"
                >
                  Show Existing Services
                </v-btn>
                <v-progress-circular
                  v-if="!servicesLoaded"
                  indeterminate
                  color="info"
                  small
                ></v-progress-circular>
              </v-flex>
              <v-flex>
                <v-layout wrap row>
                  <v-flex sm9 md8 lg8>
                    <vonex-text
                      ref="txt"
                      v-model="NumberOfIPVoices"
                      name="txt"
                      label="Number of Extensions"
                      :rule="'min:1'"
                      mask="###"
                      :options="fieldConditions"
                      @keyup="changeRows"
                    ></vonex-text>
                    <!-- <v-text-field
                      ref="txt"
                      label="Number of Extensions"
                      name="services"
                      v-model="NumberOfIPVoices"
                      :min="1"
                      @keyup="changeRows"
                      mask="###"
                    />-->
                  </v-flex>
                  <v-flex sm2 md2 lg2>
                    <v-btn title="Add Row" class="iconBtn" @click="onAdd">
                      <v-icon>add</v-icon>
                    </v-btn>
                    <br />
                    <v-btn title="Remove Row" class="iconBtn" @click="onRemove">
                      <v-icon>remove</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-flex>
            <v-flex align-end justify-center column fill-height>
              <v-radio-group
                v-model="planGroup"
                column
                value="true"
                class="ptop-0"
              >
                <v-radio
                  name="ondesk"
                  value="ondesk"
                  label="ONdesk Plans"
                ></v-radio>
                <v-radio
                  name="lineshare"
                  value="lineshare"
                  label="LineShare Plans"
                  :disabled="
                    rental || (isExistingCustomer && existingOndeskCust)
                  "
                ></v-radio>
              </v-radio-group>
            </v-flex>
            <!-- <v-flex align-end justify-center column fill-height>
              <v-flex v-if="isQantas" fluid>
                <img src="../assets/images/qantas.jpg" />
              </v-flex>
            </v-flex> -->
            <v-layout v-if="!isQantas">
              <v-flex>
                <v-radio-group
                  v-model="rental"
                  column
                  value="rental"
                  class="ptop-0"
                  @change="changeRental"
                >
                  <v-radio
                    v-if="existingRentalCustomer"
                    name="rentalHardware"
                    :value="true"
                    label="Vonex Rental Plans"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-flex color="secondary">
                    <v-radio-group
                      v-model="planType"
                      row
                      value="vonex"
                      class="ptop-0"
                      :disabled="rental"
                      @change="changeRental"
                    >
                      <v-radio
                        name="vonexSupplied"
                        value="vonex"
                        label="Vonex Supplied Hardware"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-container>
        <table
          v-show="NumberOfIPVoices > 0"
          class="table table table-striped table-bordered mobile-table"
        >
          <thead>
            <tr>
              <th scope="col" style="width: 3vw">ID</th>
              <th scope="col" style="width: 4vw">Ext.</th>
              <th scope="col">Ext Name</th>
              <th scope="col" v-if="allFlags.SOG8484 && planGroup !== 'lineshare'">Rental Hardware</th>

              <th scope="col">
                Contract Length
                <v-chip
                  v-if="!isQuote"
                  color="cyan"
                  text-color="white"
                  label
                  title="Enter DD details to see all contract options"
                >
                  <v-icon left>mdi-label</v-icon>
                  have you added DD?
                </v-chip>
              </th>
              <th scope="col" style="max-width: 10vw">
                <div>
                  <div v-show="!isQantas">
                    <span v-if="minMonthly">Minimum Monthly</span>
                    <span v-else>Mix n Match</span>
                  </div>
                  <span>Plans</span>
                </div>
                <div>
                  <v-btn
                    v-if="planGroup !== 'lineshare'"
                    color="primary"
                    small
                    round
                    title="copy down"
                    @click="copyDown('ratePlanID')"
                  >
                    Copy Down
                  </v-btn>
                </div>
              </th>
              <th scope="col" style="max-width: 18vw">
                <div>Handset</div>
                <div>
                  <v-btn
                    color="primary"
                    small
                    round
                    title="copy down"
                    @click="copyDown('handsetID')"
                  >
                    Copy Down
                  </v-btn>
                </div>
              </th>
              <th scope="col">
                <div>ANI</div>
                <div>
                  <v-btn
                    color="primary"
                    small
                    round
                    title="copy down"
                    @click="copyDown('outboundANI')"
                  >
                    Copy Down
                  </v-btn>
                </div>
              </th>
              <th scope="col">
                <div>Email</div>
                <div>
                  <v-btn
                    color="primary"
                    small
                    round
                    title="copy down"
                    @click="copyDown('voicemailEmail')"
                  >
                    Copy Down
                  </v-btn>
                </div>
              </th>
              <th scope="col">
                <div>Mobile</div>
                <div>
                  <v-btn
                    color="primary"
                    small
                    round
                    title="copy down"
                    @click="copyDown('mobileTwinning')"
                  >
                    Copy Down
                  </v-btn>
                </div>
              </th>
              <th scope="col">
                <div>Vonex Mobile App</div>
                <v-btn
                  color="primary"
                  small
                  round
                  title="Softphone"
                  @click="copyDown('softPhone')"
                >
                  Copy Down
                </v-btn>
              </th>
              <th scope="col">
                <div>Recontract</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(extension, index) in rows" :key="index">
              <td align="center">
                <div>
                  <v-icon v-show="extension.ipExtensionID" color="green">
                    check_circle
                  </v-icon>
                  <v-icon v-show="index > 0" @click="deleteRow(index)">
                    delete
                  </v-icon>
                </div>
              </td>
              <td>
                <vonex-text
                  v-model.number="extension.extensionNo"
                  class="form-control custom-td"
                  type="number"
                  :name="'extensionNo' + index"
                  :rule="'required'"
                  :options="fieldConditions"
                  hide-details
                ></vonex-text>
                <!-- <input
                  v-model.number="extension.extensionNo"
                  class="form-control"
                  v-validate="'required'"
                  :name="'extensionNo' + index"
                  type="number"
                />-->
              </td>
              <td>
                <vonex-text
                  v-model="extension.extensionName"
                  class="form-control custom-td"
                  :name="'extensionName' + index"
                  :options="fieldConditions"
                  hide-details
                ></vonex-text>
                <!-- <input
                  class="form-control"
                  :name="'extensionName' + index"
                  v-model="extension.extensionName"
                />-->
              </td>
              <td v-if="allFlags.SOG8484 && planGroup !== 'lineshare'" class="custom-checkbox">
                <vonex-checkbox
                  v-model="extension.rentalHardware"
                  :name="'rentalHardware' + index"
                  :input-value="extension.rentalHardware"
                  hide-details
                  @change="changeOrder(index)"
                ></vonex-checkbox>
              </td>
              <td>
                <vonex-select
                  v-model="extension.contractLengthMonths"
                  class="form-control custom-td"
                  name="contractLengthMonths"
                  :items="loadContractSelection(extension)"
                  item-text="description"
                  item-value="value"
                  :rule="'contractMonths'"
                  :options="fieldConditions"
                  :disabled="!allFlags.SOG8484 && index > 0"
                  hide-details
                  @input="changeOrder(index)"
                  @change="allFlags.SOG8484 ? changeOrder(index) : copyDown('contractLengthMonths')"
                ></vonex-select>
                <!-- <select
                  class="form-control"
                  v-model="extension.contractLengthMonths"
                  v-validate="'required'"
                  :name="'contractLengthMonths' + index"
                  :disabled="index > 0"
                  @change="copyDown('contractLengthMonths')"
                >
                  <option value="0">0 months</option>
                  <option v-if="!rental && !isQantas" value="12">12 months</option>
                  <option v-if="isQantas || existingRentalCustomer" value="36">36 months</option>
                </select>-->
              </td>
              <td style="min-width: 10vw; max-width: 10vw">
                <vonex-autocomplete
                  v-model="extension.ratePlanID"
                  hide-details
                  class="form-control custom-td"
                  :name="'ratePlanID' + index"
                  :rule="'planId'"
                  :items="
                    validRatePlans(
                      extension.contractLengthMonths,
                      index,
                      extension.softPhone,
                      extension.upgrade
                    )
                  "
                  dense
                  flat
                  item-value="ratePlanID"
                  item-text="ratePlanDescription"
                  :options="fieldConditions"
                  :disabled="index > 0 && planGroup == 'lineshare'"
                  @change="updateRowPlans(index)"
                >
                  <template slot="selection" slot-scope="data">
                    <span class="ellipsis">
                      {{ data.item.ratePlanDescription }}
                    </span>
                  </template>
                  <template slot="no-data">No plans available</template>
                  <template slot="item" slot-scope="data">
                    <span class="ellipsis">
                      {{ data.item.ratePlanDescription }}
                    </span>
                  </template>
                </vonex-autocomplete>
                <!-- <v-autocomplete
                  v-model="extension.ratePlanID"
                  class="form-control"
                  :name="'ratePlanID' + index"
                  :error-messages="errors.collect('ratePlanID' + index)"
                  :rules="[(v) => v > 0 || 'Rateplan is required']"
                  :items="
                    validRatePlans(
                      extension.contractLengthMonths,
                      index,
                      extension.softPhone
                    )
                  "
                  dense
                  flat
                  item-value="ratePlanID"
                  item-text="ratePlanDescription"
                >
                  <template slot="selection" slot-scope="data">
                    <span class="ellipsis">{{ data.item.ratePlanDescription }}</span>
                  </template>
                  <template slot="no-data">Choose contract length</template>
                  <template slot="item" slot-scope="data">
                    <span class="ellipsis">{{ data.item.ratePlanDescription }}</span>
                  </template>
                </v-autocomplete>-->
              </td>
              <td style="min-width: 15vw; max-width: 15vw">
                <vonex-autocomplete
                  v-model="extension.handsetID"
                  hide-details
                  class="form-control custom-td"
                  :name="'handsetID' + index"
                  :rule="'planId'"
                  :items="validHandsets(extension.ratePlanID)"
                  item-value="handsetID"
                  item-text="model"
                  dense
                  flat
                  clearable
                  :options="fieldConditions"
                  @change="isVonexSofphone(extension)"
                >
                  <template slot="selection" slot-scope="data">
                    <span class="ellipsis">
                      {{ data.item.manufacturer.description }}
                      {{ data.item.model }}
                    </span>
                  </template>
                  <template slot="no-data">Choose a Rate Plan first</template>
                  <template slot="item" slot-scope="data" class="ellipsis">
                    {{ data.item.manufacturer.description }}
                    {{ data.item.model }}
                  </template>
                </vonex-autocomplete>
                <!-- <v-autocomplete
                  v-model="extension.handsetID"
                  class="form-control"
                  :name="'handsetID' + index"
                  :rules="[(v) => v > 0 || 'Handset is required']"
                  :items="validHandsets(extension.ratePlanID)"
                  item-value="handsetID"
                  item-text="model"
                  :error-messages="errors.collect('handsetID' + index)"
                  dense
                  flat
                  clearable
                >
                  <template slot="selection" slot-scope="data">
                    <span class="ellipsis">
                      {{ data.item.manufacturer.description }}
                      {{ data.item.model }}
                    </span>
                  </template>
                  <template slot="no-data">Choose a Rate Plan first</template>
                  <template slot="item" slot-scope="data" class="ellipsis">
                    {{ data.item.manufacturer.description }}
                    {{ data.item.model }}
                  </template>
                </v-autocomplete>-->
              </td>
              <td>
                <vonex-text
                  v-model="extension.outboundANI"
                  class="form-control custom-td"
                  :name="'outboundANI' + index"
                  :rule="extension.outboundANI ? 'phonenumber' : ''"
                  :options="fieldConditions"
                  hide-details
                ></vonex-text>
                <!-- <input
                  v-model="extension.outboundANI"
                  class="form-control"
                  :name="'outboundANI' + index"
                  v-validate="extension.outboundANI ? 'phonenumber' : ''"
                />-->
              </td>
              <td>
                <vonex-text
                  v-model="extension.voicemailEmail"
                  class="form-control custom-td"
                  :name="'voicemailEmail' + index"
                  :rule="validateEmail(extension)"
                  :options="fieldConditions"
                  hide-details
                ></vonex-text>
                <!-- <input
                  v-model="extension.voicemailEmail"
                  :name="'voicemailEmail' + index"
                  v-validate="validateEmail(extension)"
                  class="form-control"
                />-->
              </td>
              <td>
                <vonex-text
                  v-model="extension.mobileTwinning"
                  class="form-control custom-td"
                  :name="'mobileTwinning' + index"
                  :rule="
                    extension.mobileTwinning !== null ? 'mobilenumber' : ''
                  "
                  :options="fieldConditions"
                  hide-details
                ></vonex-text>
                <!-- <input
                  v-model="extension.mobileTwinning"
                  class="form-control"
                  v-validate="
                    extension.mobileTwinning !== null ? 'mobilenumber' : ''
                  "
                  :name="'mobileTwinning' + index"
                />-->
              </td>
              <td class="custom-checkbox">
                <v-layout class="ma-0 pa-0">
                  <!-- <v-flex align-content-center="true" class="ma-0"> -->
                  <vonex-checkbox
                    v-model="extension.softPhone"
                    :name="'softPhone' + index"
                    :input-value="extension.softPhone"
                    hide-details
                  ></vonex-checkbox>
                  <!-- </v-flex> -->
                  <!-- <v-flex> -->
                  <v-btn
                    flat
                    small
                    :disabled="!extension.softPhone"
                    color="primary"
                    class="ma-0 pa-0"
                    @click.stop="openDialogView(extension)"
                  >
                    <span v-if="extension.softPhoneDetails.email">Edit</span>
                    <span v-else>Add Details</span>
                  </v-btn>
                  <!-- </v-flex> -->
                </v-layout>
              </td>
              <td>
                <vonex-checkbox
                  v-model="extension.upgrade"
                  :name="'upgrade' + index"
                  :input-value="extension.upgrade"
                  hide-details
                ></vonex-checkbox>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="!dealerSupplied">
            <tr>
              <th colspan="5" class="text-xs-right">
                <strong>Total (handset value + freight):</strong>
              </th>
              <td class="text-xs-right">{{ totalCost | currency }}</td>
              <td colspan="6">
                <v-alert
                  type="info"
                  :value="rows[0] && rows[0].ratePlanID == 1118"
                >
                  Note: QBR ONdesk25 can only mix with ONdesk10/20 plans.
                </v-alert>
              </td>
            </tr>
          </tfoot>
        </table>
        <p class="text-xs-right red--text">For any 24mth Contract Terms selected, a 5% discount will apply. For any 36mth Contract Terms selected, a 10% discount will apply. Discount will show on the first bill and will discontinue at the end of the contract term.</p>
        <br />
        <v-card flat>
          <div>
            <v-title>Phone Numbers</v-title>
            <v-flex class="mt-5">
              <v-layout wrap row>
                <v-flex xs2>
                  <vonex-text
                    ref="didTxt"
                    v-model="NumberOfDIDs"
                    name="txt"
                    label="Number of DIDs"
                    :rule="'min:1'"
                    mask="###"
                    :options="fieldConditions"
                    @keyup="changeDidRows"
                  ></vonex-text>
                </v-flex>
                <v-flex sm2 md2 lg2>
                  <v-btn title="Add Row" class="iconBtn" @click="onAddDid">
                    <v-icon>add</v-icon>
                  </v-btn>
                  <br />
                  <v-btn
                    title="Remove Row"
                    class="iconBtn"
                    @click="onRemoveDid"
                  >
                    <v-icon>remove</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <table
              :key="key"
              class="table table table-striped table-bordered mobile-table"
            >
              <thead>
                <tr>
                  <th scope="col-1"></th>
                  <th scope="col">Phone Number</th>
                  <th scope="col">State</th>
                  <th scope="col">Region</th>
                  <th scope="col">Range</th>
                  <!-- <th scope="col">Rateplan</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(num, index) in reservedNumbers" :key="index">
                  <td
                    class="px-auto py-auto"
                    align="center"
                    style="max-width: 30px"
                  >
                    <v-icon
                      color="red"
                      class="ml-4"
                      @click="
                        () => {
                          onRemoveReservedNumber(index);
                        }
                      "
                    >
                      delete
                    </v-icon>

                    <!-- <v-icon
                      v-if="num.did"
                      name="editDid"
                      @click="addDid(index)"
                    >
                      edit
                    </v-icon> -->
                    <v-btn
                      v-if="!num.did"
                      size="sm"
                      color="primary"
                      name="addDid"
                      class="ml-2"
                      @click="addDid(index)"
                    >
                      Add
                    </v-btn>
                  </td>
                  <td scope="col">
                    <p class="ml-2">{{ num.did }}</p>
                  </td>

                  <td scope="col">
                    <p class="ml-2">{{ num.state }}</p>
                  </td>
                  <td scope="col">
                    <p class="ml-2">{{ num.region }}</p>
                  </td>
                  <td scope="col">
                    <p class="ml-2">{{ num.range }}</p>
                  </td>
                  <!-- <td scope="col">
                  <p class="ml-2">{{ num.rate_planid }}</p>
                </td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <v-card-actions>
            <v-btn
              color="primary"
              :disabled="
                loading ||
                reservedNumbers.every((x) => x.id != 0) ||
                reservedNumbers.some((x) => x.did == '')
              "
              @click="onSubmitNumbers"
            >
              Reserve Numbers
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-container fluid>
          <v-flex xs12>
            <v-card>
              <v-card-text>
                <v-title>Call Handling</v-title>
                <v-flex xs12>
                  <v-subheader v-show="rental || isQantas">
                    First Hunt group free. Additional Hunt groups and IVR’s $5
                    per month each.
                  </v-subheader>
                  <v-radio-group
                    v-model="callHandling"
                    row
                    name="callHandlingrb"
                  >
                    <!-- v-validate="'required'"
                    :error-messages="errors.collect('callHandlingrb')"-->
                    <v-flex>
                      <v-radio
                        :label="`Direct to EXT`"
                        :value="'DirectToExtension'"
                        color="primary"
                        @change="setToCallHandling"
                      ></v-radio>
                    </v-flex>
                    <v-flex>
                      <v-radio
                        :label="`Hunt Group`"
                        name="callHandlingrb"
                        :value="'HuntGroup'"
                        color="primary"
                        @change="setToCallHandling"
                      ></v-radio>
                    </v-flex>
                    <v-flex>
                      <v-radio
                        :label="`Auto Attendant(IVR)`"
                        name="callHandlingrb"
                        :value="'AutoAttendant'"
                        color="primary"
                        @change="setToCallHandling"
                      ></v-radio>
                    </v-flex>
                  </v-radio-group>
                </v-flex>
                <v-title>Contract</v-title>
                <v-layout row wrap>
                  <v-radio-group v-model="contract" row>
                    <v-flex>
                      <v-radio
                        :label="`No Contract`"
                        name="contract"
                        :value="false"
                        color="primary"
                        :disabled="!isContract()"
                      ></v-radio>
                      <!-- v-validate="'required'"
                      :error-messages="errors.collect('contract')"-->
                    </v-flex>
                    <v-flex>
                      <v-radio
                        :label="`Contract`"
                        name="contract"
                        :value="true"
                        color="primary"
                        :disabled="isContract()"
                      ></v-radio>
                    </v-flex>
                  </v-radio-group>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-container>

        <v-flex sm12 md12 lg12>
          <v-btn
            color="primary"
            name="sbmt"
            @click="save"
          >
          <!-- :disabled="!isSaveAllowed" -->
            Save IP Order
          </v-btn>
          <message-alert :component="ipVoice.message"></message-alert>
        </v-flex>
      </v-form>
    </ValidationObserver>
  </v-container>
</template>
<script>
import ExistingServices from '@/components/dialogs/existing-services-dialog';
import { createNamespacedHelpers, mapMutations } from 'vuex';
import {
  mapIPVoiceFields,
  mapIPVoiceMultiRowFields,
} from '../store/modules/orders';
const { mapActions: mapIPVoiceActions, mapMutations: mapIPVoiceMutations } =
  createNamespacedHelpers(`orders/ipVoice`);
const { mapState: mapOrderState, mapGetters: mapOrderGetters } =
  createNamespacedHelpers(`orders`);
const { mapActions: mapCustomerActions } =
  createNamespacedHelpers(`orders/customer`);
import SoftPhone from '@/components/softphone-details';
import { SoftPhoneDetails } from '@/models/SoftPhoneDetails';
const { mapGetters: mapFeatureFlagGetters } =
  createNamespacedHelpers(`orders/featureFlag`);
import ReservedNumber from './reservedNumber.vue';
export default {
  name: 'IPExtensions',
  components: {
    SoftPhone,
    ExistingServices,
    ReservedNumber,
  },

  data() {
    return {
      planGroup: 'ondesk',
      servicesLoaded: false,
      existingDialog: false,
      valid: true,
      plans: null,
      NumberOfIPVoices: 0,
      vonexSupplied: true,
      supplier: true,
      vonex: true,
      qantas: false,
      dialog: false,
      selectedExtension: {},
      linkExts: [],
      voipServices: [],
      account: 0,
      headers: [
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Extension No.', value: 'extension', sortable: false },
        { text: 'Service', value: 'service', sortable: false },
        { text: 'Plan', value: 'plan', sortable: false },
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Added', value: 'added', sortable: false },
        { text: 'Released', value: 'released', sortable: false },
        { text: 'Contract End', value: 'contractEnd', sortable: false },
        { text: 'Recontract', value: 'upgrade', sortable: false },
      ],
      NumberOfDIDs: 0,
      phoneNumberDialog: false,
      selectedRow: null,
      selectedIndex: -1,
      reservedNumbersList: [],
      loading: false,
      key: 0, // A key that will change to force re-render
      nextAccountNo: 500,
    };
  },
  methods: {
    ...mapIPVoiceActions([
      'addIPVoice',
      'getIPVoice',
      'getHandsets',
      'getIPExtensions',
      'setMessage',
      'removeRows',
      'saveIPOrder',
      'setCallHandling',
      'removeIPFromOrder',
      'removeRow',
      'updateServiceTable',
      'getPhoneRegionsAsync',
      'getAvailablePhoneNumbersAsync',
      'reservePhoneNumbers',
      'getReservedPhoneNumbers',
      'removeReservedNumberFromOrder',
      'removeDidRows',
      'getNextAccountNo',
    ]),

    ...mapCustomerActions(['getCustomer']),
    ...mapMutations('orders', ['setOrderType', 'setAddSoftphone']),
    ...mapIPVoiceMutations([
      'addRow',
      'deleteRow',
      'setCallHandling',
      'setNewData',
      'addReservedNumber',
      'removeReservedNumber',
      'updateReservedNumbers',
    ]),
    validateEmail(item) {
      if (item) {
        let handset = this.validHandsets(item.ratePlanID).find(
          (s) => s.handsetID == item.handsetID
        );
        if (handset) {
          if (handset.model.toLowerCase().includes('softphone'))
            return 'email';

          if (item.voicemailEmail !== null) return 'email';
          else return '';
        }
      }
      return '';
    },
    addToTable(services) {
      let vm = this;
      let newRows = [];

      if (vm.rows.length > 0 && vm.rows[0].ipExtensionID == 0) {
        vm.rows.splice(0, 1);
      }
      let nextExt = vm.rows.length;
      nextExt = vm.nextAccountNo + nextExt;
      if (services.length > 0) {
        services.forEach((sv) => {
          if (services[0].plan && services[0].plan.toLowerCase().includes('lineshare')) {
            vm.planGroup = "lineshare";
          }

          let flag = vm.rows.filter((r) => r.extensionNo == sv.extensionNo);
          if (flag.length > 0) {
            vm.setMessage({
              message: 'Data is already existing on the table!',
              httpStatus: 400,
            });
            return false;
          }
          
          if (sv.extension && typeof sv.extension === 'string') {
            const ext_val = sv.extension.substring(0, 3);
            const isNumeric = /^\d+$/.test(ext_val);
            sv.extensionNo = isNumeric ? parseInt(ext_val, 10) : nextExt;
          } else {
            sv.extensionNo = nextExt;
          }

          let matchedPlan = vm.ratePlans.find((x) => x.ratePlanDescription === sv.plan);
          let planID = matchedPlan ? matchedPlan.ratePlanID : 0;

          sv.extensionName = sv.name;
          sv.ratePlanID = planID;
          sv.handsetID = 0;
          sv.upgrade = true;
          if (vm.isQantas) {
              sv.contractLengthMonths = 36;
          } else {
              if (sv.contractLengthMonths && (sv.contractLengthMonths > 0 || sv.contractLengthMonths === "36" || sv.contractLengthMonths === "24" || sv.contractLengthMonths === "12")) {
                  sv.contractLengthMonths = parseInt(sv.contractLengthMonths, 10);
              } else if (vm.rows.length > 0 && vm.rows[0]) {
                  sv.contractLengthMonths = vm.rows[0].contractLengthMonths;
              } else {
                  sv.contractLengthMonths = 12;
              }
          }

          newRows.push(sv);
          nextExt++;
        });
      }

      vm.setNewData(newRows);
      vm.setMessage({ message: 'Selected service added!', httpStatus: 200 });
      vm.NumberOfIPVoices = vm.rows.length;
    },
    addSoftPhoneToTable(services) {
      let vm = this;
      let newRows = [];
      if (vm.rows.length > 0 && vm.rows[0].ipExtensionID == 0) {
        vm.rows.splice(0, 1);
      }

      let nextExt = vm.rows.length;
      nextExt = vm.nextAccountNo + nextExt;
      if (services.length > 0) {
        let index = 0;
        services.forEach((sv) => {
          let flag = vm.rows.filter((r) => r.extensionNo == sv.extensionNo);
          if (flag.length > 0) {
            vm.setMessage({
              message: 'Data is already existing on the table!',
              httpStatus: 400,
            });
            return false;
          }
          vm.setMessage({ message: 'Data added!', httpStatus: 200 });
          sv.extensionNo =
            typeof parseInt(sv.name.substring(0, 3), 10) === 'number'
              ? sv.name.substring(0, 3)
              : nextExt;
          sv.extensionName = sv.name;

          // sv.upgrade = true;
          sv.contractLengthMonths = vm.isQantas
            ? 36
            : vm.rows[0]
            ? vm.rows[0].contractLengthMonths
            : 12;

          sv.ratePlanID = process.env.SOFTPHONE;
          sv.softPhone = true;
          sv.handsetID = vm.ipVoice.handsets.find(
            (s) =>
              s.model.toLowerCase().includes('softphone') &&
              s.manufacturer.description.toLowerCase().includes('vonex')
          ).handsetID;
          newRows.push(sv);
          nextExt++;
          index++;
        });
      }

      vm.setNewData(newRows);

      vm.NumberOfIPVoices = vm.rows.length;
    },
    setQantas(val) {
      if (val) this.setOrderType(3);
      else this.setOrderType(1);
    },
    showExistingServices() {
      this.existingDialog = true;
    },
    existingServicesLoaded(services) {
      Object.assign(
        this.voipServices,
        services.filter((x) => !x.released)
      );
      this.servicesLoaded = true;
    },
    deleteRow(index) {
      this.removeRow(index).then(() => {
        this.NumberOfIPVoices = this.rows.length;
      });
    },
    deleteFromOrder(ipOrderID) {
      let vm = this;

      this.$dialog
        .confirm(
          'You are about to delete IP from this order, this cannot be undone, are you sure?'
        )
        .then(function () {
          vm.removeIPFromOrder({ ipOrderID: ipOrderID, orderID: vm.orderID })
            .then(() => {
              vm.NumberOfIPVoices = 1;
              if (vm.qantas) vm.rows[0].contractLengthMonths = 36;
              vm.getIPExtensions();
            })
            .catch();
        })
        .catch(function () {
          //Clicked on cancel
          return;
        });
    },
    copyDown: function (column) {
      let vm = this;
      let id = vm.rows[0][column];

      for (var i = 0; i < vm.rows.length; i++) {
        vm.rows[i][column] = id;
      }
    },
    changeDealerSupplied() {
      this.rows.forEach(function (row) {
        row.dealerSupplied = true;
      });
      return;
    },
    changeVonexSupplied() {
      this.rows.forEach(function (row) {
        row.dealerSupplied = false;
      });
      return;
    },
    onAdd() {
      this.NumberOfIPVoices++;
      this.$refs.txt.$emit('keyup');
    },
    onRemove() {
      if (this.rows.length > 1) {
        this.NumberOfIPVoices--;
        this.$refs.txt.$emit('keyup');
      }
    },
    changeOrder(rowIndex) {
      const resetRow = (i) => {
        this.$set(this.rows[i], 'ratePlanID', '');
        this.$set(this.rows[i], 'handsetID', null);
      };

      if (!this.allFlags.SOG8484 || rowIndex == null) {
        this.rows.forEach((_, i) => resetRow(i));
      } else {
        resetRow(rowIndex);
      }
    },
    validHandsets(ratePlanID) {
      if (ratePlanID == 0) return [];

      let rawHandsets = this.ipVoice.handsets
        .filter(
          (x) => x.hardwareCategory.category.toLowerCase() === 'qa handset'
        )
        .filter((x) => x.status === 'active')
        .sort((a, b) => a.viewOrder - b.viewOrder);

      let ratePlan = this.ipVoice.ratePlans.find(
        (x) => x.ratePlanID === ratePlanID
      );

      if (ratePlan && ratePlan.restrictHardwareOptions === true) {
        rawHandsets = rawHandsets.filter((x) =>
          x.availableOnRatePlans.some((y) => y == ratePlanID)
        );
      }

      return rawHandsets.sort(function compare(a, b) {
        if (
          a.manufacturer.description.toLowerCase() <
          b.manufacturer.description.toLowerCase()
        )
          return;
        if (
          a.manufacturer.description.toLowerCase() >
          b.manufacturer.description.toLowerCase()
        )
          return 1;
        return 0;
      });
    },
    checkPlan: function (ratePlan, isSoftPhone) {
      return (
        ratePlan.usageType === 'DID' ||
        (ratePlan.dealerSupplied == this.dealerSupplied &&
          (ratePlan.mixnMatch === true || ratePlan.mixnMatch !== this.minMonthly) &&
          (!this.isResidential ? ratePlan.residential == false : 1 == 1) &&
          //this.isQantas == ratePlan.qantas &&
          this.rental == ratePlan.rental &&
          (this.isQuote
            ? true
            : this.isSoftPhone && isSoftPhone
            ? ratePlan.ratePlanID === process.env.SOFTPHONE
            : ratePlan.ratePlanID !== process.env.SOFTPHONE))
      );
    },
    checkPlanGroup() {
      let currentPlan = this.ratePlans.filter((x) => {
        if (x.ratePlanID === this.rows[0].ratePlanID) return x;
      });

      if (currentPlan.length > 0)
        this.planGroup = currentPlan[0].ratePlanDescription
          .toLowerCase()
          .includes('lineshare')
          ? 'lineshare'
          : 'ondesk';
    },
    validRatePlans: function (months, index, isSoftPhone, recontract) {
      let vm = this;
      //if any of the rateplans can't mix with others then limit what is shown
      if (this.rows && this.rows[0]) {
        let cannotMix =
          this.rows.length > 0 && this.rows[0].ratePlanID > 0
            ? (
                this.ratePlans.find(
                  (x) => x.ratePlanID == this.rows[0].ratePlanID
                ) || { cannotMixWithOthers: false }
              ).cannotMixWithOthers
            : false;

        if (cannotMix && index > 0) {
          let restrictedMix = this.ratePlans.find(
            (x) => x.ratePlanID == this.rows[0].ratePlanID
          )?.mixWith || [];

          if (restrictedMix.length > 0) {
            let valid = this.ratePlans.filter(
              (x) =>
                restrictedMix.includes(x.id) ||
                x.ratePlanID == this.rows[0].ratePlanID
            );
            return valid;
          }
        }

        if (vm.planGroup === 'lineshare' && vm.existingLineshareCust) {
          let linesharePlans = this.ratePlans.filter((x) => {
            if (recontract) {
              return (
                x.contractMonths == months &&
                x.ratePlanDescription.toLowerCase().includes('lineshare')
              );
            }
            return x.ratePlanID == 2308 || x.ratePlanID == 3210;
          });
          return linesharePlans;
        }

        const row = this.rows[index];
        const isRentalHardwareRow = this.allFlags.SOG8484 && row && row.rentalHardware === true;
        const effectiveMonths = isRentalHardwareRow ? 36 : months;

        let result = this.ratePlans
          .filter((x) => x.archived == false)
          .filter((x) => this.checkPlan(x, isSoftPhone))
          .filter((x) =>
            index > 0 ? x.cannotMixWithOthers == cannotMix : true
          )
          .filter((e) => {
            // If Plans with Handset Rental
            if (this.isQantas) {
              return e.grenkeFinance === true;
            }
            // If not Plans with Handset Rental
            if (!this.isQantas) {
              return e.grenkeFinance === false;
            }
            return true;
          })
          .filter((e) => {
            return !this.minMonthly ? e.contractMonths == effectiveMonths : true;
          })
          .filter((e) =>
            !this.rental
              ? e.ratePlanDescription.toLowerCase().includes(this.planGroup) ||
                e.ratePlanDescription.toLowerCase().includes('teams') ||
                e.ratePlanDescription.toLowerCase().includes('soft phone') ||
                e.ratePlanDescription.toLowerCase().includes('softphone')
              : e.rental
          );
        
        if (this.allFlags.SOG8484 && row) {
          const isRentalHardware = row.rentalHardware === true;
          result = result.filter((e) => (e.rentalHardware === true) === isRentalHardware);
        }

        result = result.sort(function (a, b) {
          var nameA = a.ratePlanDescription.toLowerCase();
          var nameB = b.ratePlanDescription.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          return 0;
        });

        return result;
      }
    },
    openDialogView(extension) {
      let vm = this;

      if (!extension.softPhoneDetails) {
        extension.softPhoneDetails = new SoftPhoneDetails();
      }
      vm.selectedExtension = extension;

      vm.dialog = true;
    },
    updateExtension(payload) {
      if (payload) {
        this.selectedExtension = payload;
      }
      this.dialog = false;
    },
    async save() {
      let vm = this;

      if (!this.$refs.form.validate()) {
        vm.setMessage({
          message: 'Unable to save: Check the highlighted fields above',
          httpStatus: 500,
        });
        return;
      }
      vm.$refs.observer
        .validate()
        .then(async (result) => {
          if (result) {
            if (
              vm.isGrenke &&
              vm.isQantas &&
              vm.totalCost > 0 &&
              vm.totalCost < 500.0
            ) {
              vm.setMessage({
                message: 'Qantas Order must be at least $500',
                httpStatus: 500,
              });
              return;
            }
            try {
              let ip = await vm.saveIPOrder();
              let voice = await vm.addIPVoice();

              await Promise.all([ip, voice]);
              vm.getIPExtensions();
            } catch (err) {
              vm.setMessage({ message: err, httpStatus: 500 });
            }
          } else {
            vm.setMessage({
              message: 'Unable to save: Check the highlighted fields above',
              httpStatus: 500,
            });
          }
        })
        .catch(function (err) {
          vm.setMessage({ message: err, httpStatus: 500 });
        });
    },
    changeRows: function () {
      let vm = this;
      var oldVal = 0 || vm.rows.length;
      var newVal = vm.NumberOfIPVoices;

      if (parseInt(oldVal, 10) > parseInt(newVal, 10)) {
        vm.$dialog
          .confirm('You are about to delete rows, are you sure?')
          .then(function () {
            vm.removeRows(newVal).then(function () {
              vm.NumberOfIPVoices = vm.rows.length;
            });
          })
          .catch(function () {
            //Clicked on cancel
            vm.NumberOfIPVoices = oldVal;
            return;
          });
      } else {
        if (newVal > vm.rows.length)
          for (var i = oldVal; i < newVal; i++) {
            vm.addRow(
              vm.isQantas
                ? 36
                : vm.rows[0]
                ? vm.rows[0].contractLengthMonths
                : 12
            );
            vm.rows[i].extensionNo = nextAccountNo + i;
          }
      }
    },
    changeDidRows: function () {
      let vm = this;
      var oldVal = 0 || vm.reservedNumbers.length;
      var newVal = vm.NumberOfDIDs;
      if (parseInt(oldVal, 10) > parseInt(newVal, 10)) {
        vm.$dialog
          .confirm('You are about to delete rows, are you sure?')
          .then(function () {
            vm.removeDidRows(newVal).then(function () {
              vm.NumberOfDIDs = vm.reservedNumbers.length;
            });
          })
          .catch(function () {
            //Clicked on cancel
            vm.NumberOfDIDs = oldVal;
            return;
          });
      } else {
        if (newVal > vm.reservedNumbers.length)
          for (var i = oldVal; i < newVal; i++) {
            vm.addReservedNumber({
              domain_name: '',
              customer_number: this.customer.customer.ubAccountNo,
              did: '',
              ratePlanId: 0,
              addressId: 0,
              id: 0,
              directoryListing: 'UL',
              ipnd_action: 'ADD',
              is_temp_preport: true,
              range: 0,
              state: '',
              region: '',
              orderId: vm.orderID,
              from_update: false,
            });
          }
      }
    },
    createIPVoice: function () {
      let vm = this;
      vm.$refs.observer.validate().then((result) => {
        if (result) {
          vm.saveIPOrder();
        }
      });
    },
    isContract: function () {
      var vm = this;
      if (vm.rows.filter((s) => s.contractLengthMonths == 0).length > 0) {
        this.contract = false;
        return true;
      }
      this.contract = true;
      return false;
    },
    setToCallHandling: function (value) {
      var vm = this;
      vm.setCallHandling(value);
    },
    isVonexSofphone(extension){
      if(extension.handsetID == 10016) return extension.softPhone = true
      return extension.softPhone = false;
    },
    changeRental(val) {
      let vm = this;
      switch (val) {
        case true:
          this.dealerSupplied = false;
          this.minMonthly = false;
          this.rows[0]['contractLengthMonths'] = 36;
          this.planType = 'vonex';
          this.planGroup = 'ondesk';

          this.copyDown('contractLengthMonths');
          break;
        case false:
        case 'vonex':
          this.planType = 'vonex';
          this.dealerSupplied = false;
          // this.rows[0]['contractLengthMonths'] = vm.isQantas ? 36 : 12;
          this.copyDown('contractLengthMonths');
          break;
        case 'dealer':
          this.planType = 'dealer';
          this.rental = false;
          this.dealerSupplied = true;
          // this.rows[0]['contractLengthMonths'] = vm.isQantas ? 36 : 12;
          this.copyDown('contractLengthMonths');
          break;
      }
    },
    hasSoftphoneEmail(extension) {
      if (extension.softPhone && !extension.softPhoneDetails.email)
        return false;
      return true;
    },
    loadContractSelection(extension) {
      let selections = [{ description: '0 months', value: 0 }];

      if (this.hasNoDDProvided && !this.isQuote) return selections;

      if (this.allFlags.SOG8484 && extension.rentalHardware) {
        selections.push({ description: '36 months', value: 36 });
        selections = selections.filter((x) => x.value !== 0);
        return selections;
      }

      const isStandardPlan = !this.isQantas;

      // Qantas (QBR) Plans
      if (this.isQantas || this.existingRentalCustomer) {
        selections.push({ description: '36 months', value: 36 });
      }

      // Standard (Non-Qantas) Plans
      if (!this.rental && isStandardPlan) {
        selections.push({ description: '12 months', value: 12 });
        selections.push({ description: '24 months', value: 24 });
        selections.push({ description: '36 months', value: 36 });
      }

      // Ondesk-specific rule: allow 24 months if certain conditions are met
      if (
        this.planGroup === 'ondesk' &&
        this.customer.customer &&
        !this.isQantas &&
        !this.isFinance
      ) {
        const has24Months =
          this.customer.customer.companyDetails &&
          this.customer.customer.companyDetails.companyName
            .toLowerCase()
            .includes('manly warringah cabs (trading)');

        if (
          this.allFlags['SOG5034'] &&
          has24Months &&
          !selections.some((e) => e.value === 24)
        ) {
          selections.push({ description: '24 months', value: 24 });
        }
      }

      return selections;
    },
    updateRowPlans(index) {
      let vm = this;
      if (vm.planGroup == 'lineshare' && index == 0) {
        vm.rows.forEach((el) => (el.ratePlanID = vm.rows[0].ratePlanID));
      }
    },
    onAddDid() {
      ++this.NumberOfDIDs;
      this.$refs.didTxt.$emit('keyup');
    },
    onRemoveDid() {
      --this.NumberOfDIDs;
      this.$refs.didTxt.$emit('keyup');
    },
    onRemoveReservedNumber(index) {
      const vm = this;
      const currentRow = vm.reservedNumbers[index];
      vm.$dialog
        .confirm('You are about to delete row, are you sure?')
        .then(function () {
          if (currentRow.did && currentRow.id > 0) {
            vm.removeReservedNumberFromOrder({
              orderId: vm.orderID,
              id: currentRow.id,
            });
          } else {
            vm.removeReservedNumber(index);
            vm.onRemoveDid();
          }
        })
        .catch(function () {
          //Clicked on cancel
          return;
        });
    },
    async addDid(index) {
      const vm = this;
      this.selectedRow = this.reservedNumbers[index];
      let plainObject = {
        addressId: this.selectedRow.addressId,
        customerNumber: this.customer.customer.ubAccountNo,
        did: this.selectedRow.did,
        directoryListing: this.selectedRow.directoryListing,
        domainName: this.selectedRow.domainName,
        fromUpdate: this.selectedRow.fromUpdate,
        id: this.selectedRow.id,
        ipExtensionId: this.selectedRow.ipExtensionId,
        ipndAction: this.selectedRow.ipndAction,
        isTempPreport: this.selectedRow.isTempPreport,
        orderId: this.selectedRow.orderId,
        range: this.selectedRow.range,
        ratePlanId: this.selectedRow.ratePlanId,
        region: this.selectedRow.region,
        state: this.selectedRow.state,
      };
      this.selectedRow = { ...plainObject };
      this.selectedIndex = index;

      if (this.selectedRow.did) {
        this.getPhoneRegionsAsync(plainObject).then(async (res) => {
          var temp_regions = res;
          var current_region = temp_regions.find(
            (x) => x.description == plainObject.region
          );

          var request = {
            quantity: plainObject.range,
            region: plainObject.region,
            pageSize: current_region.count,
          };
          await vm.getAvailablePhoneNumbersAsync({ request });
          this.phoneNumberDialog = true;
        });
      } else {
        this.phoneNumberDialog = true;
      }
      this.loading = false;
    },
    onAddReservedNumber(data) {
      //this.reservedNumbers[this.selectedIndex] = data;
      this.updateReservedNumbers({ selectedIndex: this.selectedIndex, data }); //update the vuex state
      this.reservedNumbersList = this.reservedNumbers;

      this.selectedIndex = -1;
      this.selectedRow = null;
      this.phoneNumberDialog = false;
      this.key += 1;
    },
    closeDialog() {
      this.phoneNumberDialog = false;
    },
    async onSubmitNumbers() {
      const vm = this;
      const request = {
        orderId: vm.orderID,
      };
      await vm.reservePhoneNumbers(request);
      vm.loading = true;
    },
  },
  computed: {
    ...mapOrderGetters([
      'isExistingCustomer',
      'isQantas',
      'isFinance',
      'isGrenke',
      'totalCost',
      'isSoftPhone',
      'isQuote',
      'isPayingWithCreditCard',
      'hasNoDDProvided',
      'isResidential',
    ]),

    ...mapIPVoiceMultiRowFields([
      'rows',
      'reservedNumbers',
      'phoneRegions',
      'ratePlans',
    ]),
    ...mapOrderState([
      'ipVoice',
      'isResidential',
      'dealer',
      'customer',
      'company',
    ]),
    ...mapOrderState({ order: 'rows' }),
    ...mapIPVoiceFields([
      'iporder.contract',
      'iporder.dealerSupplied',
      'iporder.minMonthly',
      'iporder.callHandling',
      'iporder.amptDomainName',
      'iporder.isCreatedByAMPT',
      'iporder.rental',
      'iporder.planType',
      'iporder.ipOrderID',
      'iporder.orderID',
      'iporder.existingRentalCustomer',
    ]),

    ...mapFeatureFlagGetters(['allFlags']),
    showButton() {
      let vm = this;

      return vm.customer.customer.ubAccountNo > 0;
    },
    isSaveAllowed() {
      if (this.rows.some((s) => s.softPhone && !s.softPhoneDetails.email))
        return false;
      return true;
    },
    existingLineshareCust() {
      let vm = this;
      return (
        vm.customer.customer.ubAccountNo > 0 &&
        vm.customer.customer.hasLineshare === true
      );
    },
    existingOndeskCust() {
      let vm = this;

      return (
        vm.customer.customer.ubAccountNo > 0 &&
        vm.customer.customer.hasOndeskService &&
        !vm.customer.customer.hasLineshare
      );
    },
    filteredReservedNumbers() {
      let vm = this;
      return vm.reservedNumbers;
    },
  },

  async mounted() {
    let vm = this;
    if (vm.isResidential) vm.$router.push('/create-sip');

    vm.isCreatedByAMPT = false;
    await vm.getCustomer(vm.customer.customer.customerID);

    var _nextAccount = await vm.getNextAccountNo({
      customerNumber: vm.customer.customer.ubAccountNo,
      groupNo: vm.dealer.dealer.groupNo ? +vm.dealer.dealer.groupNo : 1,
    });
    vm.nextAccountNo = _nextAccount;

    let handsets = await vm.getHandsets();
    let ipvoice = await vm.getIPVoice();
    let exts = await vm.getIPExtensions();
    let numbers = await vm.getReservedPhoneNumbers({ orderId: vm.orderID });
    vm.NumberOfDIDs = vm.reservedNumbers.length;

    await Promise.all([handsets, exts, ipvoice, numbers]);
    if (
      vm.isSoftPhone &&
      (vm.rows.length == 0 || (vm.rows && vm.rows[0].ipExtensionID == 0))
    ) {
      vm.existingDialog = true;
      return;
    } else {
      if (vm.rows.length == 0) {
        vm.addRow(vm.isQantas ? 36 : 12);
        vm.rows[0].extensionNo = vm.nextAccountNo;
      }
      if (vm.isQantas) {
        vm.qantas = true;
      }
      vm.NumberOfIPVoices = vm.rows.length;
    }
    if (vm.rows.some((s) => s.ratePlanID === process.env.SOFTPHONE))
      vm.setAddSoftphone(true);
    else if (vm.isSoftPhone && vm.rows.length == 0) this.existingDialog = true;

    this.checkPlanGroup();
    vm.reservedNumbersList = numbers;
  },
};
</script>
<style scoped lang="scss">
@import '@/assets/custom-styles.scss';
.small {
  height: 14px;
}
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.inputPrice input[type='number'] {
  -moz-appearance: textfield;
}
.inputPrice input::-webkit-outer-spin-button,
.inputPrice input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.ellipsis {
  text-overflow: ellipsis;
  max-width: 10vw;
  overflow: hidden;
  white-space: nowrap;
  font-size: small !important;
}
</style>
